<template>
	<h4 class="reg my-1 mb-4">
		<BackButton :goBackName="goBackName" :params="goBackParams" width="25" height="25" icon="back" class="btn-back" />
		<span class="clickable-path">
			<span class="item" @click="goToRootGroups()"> Groups </span>
			<span class="item" v-for="group in pathItems" :key="group.id" @click="goToSpecificGroup(group)">
				<span class="item-divider"> > </span>
				{{ group.name }}</span
			>
		</span>
	</h4>
</template>

<script>
import { mapGetters } from 'vuex';
import BackButton from '@/components/common/BackButton';
import { groupPathItems } from '@/store/modules/accountGroups/getters';

const SPECIFIC_GROUP_ROUTE_NAME = 'ManageSingleGroup';
const ROOT_GROUPS_ROUTE_NAME = 'ManageGroups';

export default {
	name: 'GroupTopBar',
	components: {
		BackButton,
	},
	props: {
		group: { type: Object },
		notFound: { type: Boolean },
	},
	computed: {
		...mapGetters([groupPathItems.fullPath]),
		text() {
			return this.notFound ? 'Group not found' : `Groups ${this.fullPath}`;
		},
		pathItems() {
			if (!this.group) {
				return;
			}
			return this[groupPathItems.fullPath](this.group);
		},
		goBackParams() {
			if (!this.group?.parent) {
				return null;
			}
			return { groupId: this.group.parent };
		},
		goBackName() {
			return this.group?.parent ? SPECIFIC_GROUP_ROUTE_NAME : ROOT_GROUPS_ROUTE_NAME;
		},
	},
	watch: {},
	methods: {
		goToRootGroups() {
			this.$router.push({
				name: ROOT_GROUPS_ROUTE_NAME,
			});
		},
		goToSpecificGroup(group) {
			const payload = {
				name: SPECIFIC_GROUP_ROUTE_NAME,
				params: { groupId: group.id },
			};
			this.$router.push(payload);
		},
	},
};
</script>

<style scoped lang="scss">
.btn-back {
	padding: 0px !important;
	margin-right: 2px;
	::v-deep {
		.v-btn__content {
			top: -2px;
		}
	}
}
.clickable-path {
	cursor: pointer;
	.item {
		margin-right: 4px;

		&:hover {
			font-weight: 700;
			.item-divider {
				font-weight: 400;
			}
		}
	}
}
</style>
